import React, { useEffect, useState } from 'react';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {
  BUZZONE_SCHOOLS_ROUTE,
  BUZZONE_STAFFS_ROUTE,
  BUZZONE_STUDENTS_ROUTE,
} from '../../routes/routes';
const linkStyle = {
  height: 64,
  paddingLeft: 16,
  paddingRight: 16,
  marginTop: 8,
  marginBottom: 8,
  borderRadius: 4,
};

const useStyles = makeStyles((theme) => ({
  overAll: { paddingLeft: 5, paddingRight: 5 }, // 438
  linkStyle: {
    ...linkStyle,
  },
  linkStyleActive: {
    ...linkStyle,
    backgroundColor: theme.palette.buzzActiveLinkBackground,
  },
  textStyle: {
    textDecoration: 'none',
  },
}));

const isActiveRoute = (routeName, pathName) => {
  return routeName.includes(pathName);
};

export default function BuzzOneSideNavBar() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const theme = useTheme();

  const initialPaths = [
    {
      name: 'Schools',
      link: BUZZONE_SCHOOLS_ROUTE,
    },
    {
      name: 'Staffs',
      link: BUZZONE_STAFFS_ROUTE,
    },
    {
      name: 'Students & Parents',
      link: BUZZONE_STUDENTS_ROUTE,
    },
  ];

  const [selectedPaths, setSelectedPaths] = useState(initialPaths);
  const [isShowingNestedPath, setIsShowingNestedPath] = useState(false);

  useEffect(() => {
    initialPaths.map(({ links }) => {
      if (
        links &&
        isActiveRoute(
          links.map(({ link }) => link),
          pathname
        )
      ) {
        setSelectedPaths(links);
        setIsShowingNestedPath(true);
      }
    });
  }, []);

  return (
    <Box
      flex={2}
      mr={3}
      border={1}
      borderColor={theme.palette.buzzBorder}
      borderRadius={4}
      className={classes.overAll}>
      {isShowingNestedPath && (
        <Box
          onClick={() => {
            setSelectedPaths(initialPaths);
            setIsShowingNestedPath(false);
          }}
          className={classes.linkStyleActive}
          display="flex"
          alignItems="center"
          style={{ cursor: 'pointer' }}>
          <ChevronLeftIcon color="primary" />
          <Box flexGrow={1}>
            <Typography color="textPrimary" component="div">
              <Box fontWeight={'fontWeightMedium'}>{'Back'}</Box>
            </Typography>
          </Box>
        </Box>
      )}

      {selectedPaths.map((path) => {
        const isActive = isActiveRoute(
          path.link || path.links.map(({ link }) => link),
          pathname
        );
        return (
          <Link
            key={path.name}
            to={path.link ? path.link : path.links[0].link}
            color="inherit"
            className={classes.textStyle}>
            <Box
              onClick={() => {
                if (path.link) return;

                setSelectedPaths(path.links);
                setIsShowingNestedPath(true);
              }}
              className={isActive ? classes.linkStyleActive : classes.linkStyle}
              display="flex"
              alignItems="center">
              <Box flexGrow={1}>
                <Typography color="textPrimary" component="div">
                  <Box fontWeight={isActive ? 'fontWeightMedium' : ''}>
                    {path.name}
                  </Box>
                </Typography>
              </Box>
              {isActive && <ChevronRightIcon color="primary" />}
            </Box>
          </Link>
        );
      })}
    </Box>
  );
}
